import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import Home from './pages/Home';
import ProjectsPortfolio from './pages/ProjectsPortfolio';
import CoreServices from './pages/CoreServices';
import Leadership from './pages/Leadership';
import ProjectDetailPage from './pages/ProjectDetailPage';
import About from './pages/About';
import Contact from './pages/Contact';
import News from './pages/InvestmentOpportunities';
import FinancialPerformance from './pages/FinancialPerformance';
import Location from './pages/Location';
import PrivacyPolicy from './pages/PrivacyPolicy';
import './App.css';
import PortfolioPage from './pages/Portfolio';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainLayout><Home /></MainLayout>} />
        <Route path="/portfolio-summary" element={<MainLayout><ProjectsPortfolio /></MainLayout>} />
        <Route path="/projects/:id" element={<MainLayout><ProjectDetailPage /></MainLayout>} />
        <Route path="/leadership" element={<MainLayout><Leadership /></MainLayout>} />
        <Route path="/core-services" element={<MainLayout><CoreServices /></MainLayout>} />
        <Route path="/about-us" element={<MainLayout><About /></MainLayout>} />
        <Route path="/contact" element={<MainLayout><Contact /></MainLayout>} />
        <Route path="/news-insights" element={<MainLayout><News /></MainLayout>} />
        <Route path="/financial-performance" element={<MainLayout><FinancialPerformance /></MainLayout>} />
        <Route path="/locations" element={<MainLayout><Location /></MainLayout>} />
        <Route path="/portfolio" element={<MainLayout><PortfolioPage /></MainLayout>} />
        <Route path="/privacy-policy" element={<MainLayout><PrivacyPolicy /></MainLayout>} />
        </Routes>
    </Router>
  );
}

export default App;
